import React from 'react'
import PropTypes from 'prop-types'
import { links, constants, snowplow } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import CommonButton from 'components/buttons/CommonButton/CommonButton'

import messages from './messages'
import s from './SubscribeTodayForJust.scss'


const SubscribeTodayForJust = ({ isLoggedIn, id }) => (
  <aside className={s.section}>
    <FormattedMessage tag="p" {...messages.subscribeTodayForJust} />
    <CommonButton
      md
      brand
      fullWidth
      subscribeNow
      to={isLoggedIn ? links.subscribe : links.register}
      id={id || 'subscribeButton'}
      onClick={() => {
        snowplow.track(constants.snowplowEvents.subscribeNowLinkClick, {
          placement: 'sidebar',
        }, false)
      }}
    />
  </aside>
)

SubscribeTodayForJust.propTypes = {
  isLoggedIn: PropTypes.bool,
}


export default SubscribeTodayForJust
